import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {PaymentScheduleSearchParams} from "../types/PaymentScheduleSearchParams";
import {PaymentScheduleDetailsResult} from "../types/PaymentScheduleDetailsResult";

export const useGetPaymentScheduleDetails = (params: PaymentScheduleSearchParams) => {
	const { data, isLoading } = useQuery({
		queryKey: [params],
		queryFn: async () => await apiClient.get('payment-schedule/details', {
			params: params
		}) as PaymentScheduleDetailsResult
	});

	return {
		data,
		isLoading
	};
};
